<template>
  <fragment>
    <Title :title="title"></Title>
    <div class="layout-view withoutTitle">
      <div class="components-layout text-list">
        <div :id="`events-layout-${scrollId}`">
          <ul class="text-list-ul" :id="scrollId">
            <li v-for="(item, index) in dataSource" :key="index">
              {{ item.orgName || item.name }}
            </li>
          </ul>
        </div>
      </div>
      <EmptyData v-if="isEmpty" />
    </div>
  </fragment>
</template>

<script>
import { getCacheOrRequest, createUniqueKey } from "@/utils/index.js";
import ComponentBase from "@/components/mixin/ComponentBase.vue";
import Title from "@/components/common/Title.vue";
import EmptyData from "@/components/common/EmptyData.vue";

export default {
  mixins: [ComponentBase],
  components: { Title, EmptyData },
  data() {
    return {
      scrollId: createUniqueKey(12),
      dataSource: [],
      autoScrollObject: null,
      group: {
        服务类型: {
          url: "/home/getServiceTypeList",
          method: "get",
          callBack: (response) => {
            this.dataSource = response.data.data || [];
          },
        },
        社区幸福院: {
          url: "/org/getOrgList",
          method: "post",
          callBack: (response) => {
            this.dataSource = response.data.data.filter((item) => {
              return item.personnelCategory == "幸福院";
            });
          },
        },
        机构养老: {
          url: "/org/getOrgList",
          method: "post",
          callBack: (response) => {
            this.dataSource = response.data.data.filter((item) => {
              return item.personnelCategory == "福利院";
            });
          },
        },
        入库供应商: {
          url: "/org/getOrgList",
          method: "post",
          callBack: (response) => {
            this.dataSource = response.data.data.filter((item) => {
              return item.personnelCategory == "服务商";
            });
          },
        },
      },
    };
  },
  props: {
    title: {
      type: String,
      default: "",
    },
  },
  methods: {
    get_component_data() {
      if (!this.group[this.title]) {
        return;
      }
      getCacheOrRequest.call(this, {
        method: this.group[this.title].method,
        url: this.group[this.title].url,
        success: (response) => {
          this.group[this.title].callBack(response);
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.text-list {
  display: flex;
  overflow: hidden;
  ul.text-list-ul {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    overflow-y: scroll;
    height: 100%;
    justify-content: space-between;
    align-content: flex-start;
    padding: 2.5%;
    li {
      width: calc(~"(100% - 20px)  / 2");
      background-color: rgb(3, 84, 223);
      border-radius: 20px;
      padding: 20px;
      font-size: 0.3rem;
      font-weight: 700;
      color: #fff;
      text-align: center;
      margin-bottom: 3%;
      display: flex;
      justify-content: center;
      border-radius: 300px;
      align-items: center;
      height: 0.7rem;
      &:nth-last-child(2),
      &:last-child {
        margin-bottom: 0%;
      }
    }
  }
}
.abs .text-list-ul {
  padding: 2.5% !important;
  li {
    font-size: 0.38rem !important;
    height: 1.4rem !important;
    width: calc((100% - 20px) / 2.1) !important;
  }
}
</style>
